import React from 'react';
import {Layout} from "antd";
import {CharacterBuilder} from "./Components/CharacterBuilder";
import {ItemInfo} from "./Components/Boilerplate/ItemInfo";
import './App.less';

function App() {
  return (
    <Layout className="layout">
      {/*<Layout.Header>*/}
      {/*  <div className="logo"/>*/}
      {/*  <Menu*/}
      {/*    theme="dark"*/}
      {/*    mode="horizontal"*/}
      {/*    defaultSelectedKeys={['2']}*/}
      {/*    style={{lineHeight: '64px'}}*/}
      {/*  >*/}
      {/*    <Menu.Item key="1">nav 1</Menu.Item>*/}
      {/*    <Menu.Item key="2">nav 2</Menu.Item>*/}
      {/*    <Menu.Item key="3">nav 3</Menu.Item>*/}
      {/*  </Menu>*/}
      {/*</Layout.Header>*/}
      <Layout.Content style={{padding: '0 50px', height: 'calc(100vh - 69px)'}}>
        {/*<Breadcrumb style={{margin: '16px 0'}}>*/}
        {/*  <Breadcrumb.Item>Home</Breadcrumb.Item>*/}
        {/*  <Breadcrumb.Item>List</Breadcrumb.Item>*/}
        {/*  <Breadcrumb.Item>App</Breadcrumb.Item>*/}
        {/*</Breadcrumb>*/}
        <div style={{marginTop: 50, padding: 24, minHeight: 680}}>
          <ItemInfo/>
          <CharacterBuilder/>
        </div>
      </Layout.Content>
      <Layout.Footer style={{textAlign: 'center'}}>The World RPG Character Builder &copy;2019 Created by
        Te&chi;nical, data by Lee</Layout.Footer>
    </Layout>
  );
}

export default App;
